import React, { useState, useEffect } from 'react';
import axios from 'axios';
import HistoryTable from "../component/HistoryTable"; // Assuming you have a HistoryTable component
import { useConnectWallet } from '@web3-onboard/react';
const BridgeHistoryTable = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

 const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
  const targetAddress = wallet?.accounts[0].address

  const headers = [
    // { label: "Transaction Hash", name: "sendTxHash" },
    { label: "From", name: "fromChain" },
    { label: "To", name: "toChain" },
    { label: "Time", name: "timestamp" },
    { label: "Status", name: "status" },
  
  ];

  const fetchData = async () => {
    try {
      // Use a public CORS proxy
      const response = await axios.get('https://api.allorigins.win/get?url=' + encodeURIComponent('https://testnet.wanscan.org/api/cc/msg/tx'));
      

      // Parse the JSON data from the response
      const jsonData = JSON.parse(response.data.contents);
      
      // Filter transactions by the specified "from" address
      const filteredData = jsonData.filter(item => item.from.toLowerCase() === targetAddress.toLowerCase());
      
      setData(filteredData);
      
    } catch (error) {
      console.error('Error fetching data:', error.response ? error.response : error);
      setError(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, [wallet]);

  return (
    <div className="" style={{ overflow: 'scroll', scrollbarWidth: 'none' }}>
      <HistoryTable headers={headers} data={data.map(item => ({
        ...item,
        timestamp: new Date(item.timestamp * 1000).toLocaleString() // Format timestamp
      }))} />
    </div>
  );
};

export default BridgeHistoryTable;